var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editorcontainer"},[_c('editor',{attrs:{"id":"app-editor","api-key":"jh5j9j89wyv5mbctvucc67e0o5ba3q7v4xkldjfoaqv74glt","init":_vm.inital},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }